package com.tixforgigs.common.core.util

import com.tixforgigs.common.core.extensions.BuildKonfigUtil
import com.tixforgigs.common.core.extensions.orElse
import com.tixforgigs.common.http.HttpClient
import com.tixforgigs.apax.models.ImageSize
import com.tixforgigs.apax.models.ImageType
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import kotlinx.coroutines.launch
import kotlinx.datetime.LocalTime
import web.dom.ElementId
import web.dom.document
import web.navigator.navigator
import web.scroll.*
import kotlin.time.Clock
import kotlin.time.Duration.Companion.seconds
import kotlin.time.Instant
import kotlin.uuid.Uuid

object UiUtil {

  const val APP_CONTAINER_ID = "app"

  fun imageUrl(
    size: ImageSize,
    id: Uuid? = null,
    type: ImageType = ImageType.WEBP,
    showDefault: Boolean = false
  ): String? {
    return id?.let { imageUuid ->
      buildString {
        append(BuildKonfigUtil.calculateApiUrl(HttpClient.FLAVOR))
        append("/media/resize")
        append("/${type.value}")
        append("/${size.value}")
        append("/${imageUuid}")
      }
    }.orElse {
      if (showDefault) "modules/local/assets/images/splash-index_square.webp"
      else null
    }
  }


  var appBase = document.documentElement.getAttribute("data-base-path").orElse { "/" }

  fun soonAvailableLocalTimeFlow(target: Instant): Flow<LocalTime?> = flow {
    while (true) {
      val remainingSec = (target - Clock.System.now()).inWholeSeconds
      if (remainingSec < 0L) {
        emit(null)
        break
      }
      emit(LocalTime.fromSecondOfDay(remainingSec.toInt()))
      delay(1.seconds)
    }
  }

  fun scrollTop(behavior: ScrollBehavior = ScrollBehavior.Companion.smooth, id: String) {
    MainScope().launch {
      document.getElementById(ElementId(id))?.scrollIntoView(
        options = ScrollIntoViewOptions.Companion(
          behavior = behavior,
          block = ScrollLogicalPosition.Companion.start,
          inline = ScrollLogicalPosition.Companion.start
        )
      )
    }
  }

  fun scrollCenter(behavior: ScrollBehavior = ScrollBehavior.Companion.smooth, id: String) {
    MainScope().launch {
      document.getElementById(ElementId(id))?.scrollIntoView(
        options = ScrollIntoViewOptions.Companion(
          behavior = behavior,
          block = ScrollLogicalPosition.Companion.center,
          inline = ScrollLogicalPosition.Companion.center
        )
      )
    }
  }

  fun scrollBottom(behavior: ScrollBehavior = ScrollBehavior.Companion.smooth, id: String) {
    MainScope().launch {
      document.getElementById(ElementId(id))?.scrollIntoView(
        options = ScrollIntoViewOptions.Companion(
          behavior = behavior,
          block = ScrollLogicalPosition.Companion.end,
          inline = ScrollLogicalPosition.Companion.end
        )
      )
    }
  }

  fun getPlatform(): MobileDevice {
    if ("/android/".toRegex().matches(navigator.userAgent)) {
      return MobileDevice.ANDROID
    }
    if ("/iPad|iPhone|iPod/".toRegex().matches(navigator.userAgent)) {
      return MobileDevice.IOS
    }
    return MobileDevice.DESKTOP
  }


  enum class MobileDevice {
    ANDROID,
    IOS,
    DESKTOP
  }
}